<script setup>
import { onMounted, onUnmounted, reactive } from 'vue'
const props = defineProps({
 
})

onMounted(() => {
  
})
onUnmounted(() => { })
</script>
<template>
  <table class="spec-table">
    <thead>
      <tr>
        <th></th>
        <th></th>
        <th>S</th>
        <th>M</th>
        <th>L</th>
        <th>XL</th>
        <th>XXL</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><span class="legend">TTH.</span></td>
        <td><span class="value">Top Tube Length – HORZ</span> <span class="unit">(mm)</span></td>
        <td>567mm</td>
        <td>592mm</td>
        <td>617mm</td>
        <td>648mm</td>
        <td>668mm</td>
      </tr>
      <tr>
        <td><span class="legend">HTA.</span></td>
        <td><span class="value">Head Tube Angle </span><span class="unit">(deg)</span></td>
        <td>68.6°</td>
        <td>68.7°</td>
        <td>68.7°</td>
        <td>68.7°</td>
        <td>68.7°</td>
      </tr>
      <tr>
        <td>HTL.</td>
        <td><span class="value">Head Tube length</span> <span class="unit">(mm)</span></td>
        <td><i>93mm</i></td>
        <td><i>103mm</i></td>
        <td><i>118mm</i></td>
        <td><i>128mm</i></td>
        <td><i>143mm</i></td>
      </tr>
      <tr>
        <td>STA.</td>
        <td><span class="value">Seat Tube Angle – Effective</span> <span class="unit">(deg)</span></td>
        <td>74.1°</td>
        <td>74.2°</td>
        <td>74.2°</td>
        <td>74.2°</td>
        <td>74.2°</td>
      </tr>
      <tr>
        <td><span class="legend">STL.</span></td>
        <td><span class="value">Seat Tube length</span> <span class="unit">(mm)</span></td>
        <td>394mm</td>
        <td>432mm</td>
        <td>470mm</td>
        <td>508mm</td>
        <td>546mm</td>
      </tr>
      <tr>
        <td>RC.</td>
        <td><span class="value">Rear Centre</span> <span class="unit">(mm)</span></td>
        <td>439mm</td>
        <td>439mm</td>
        <td>439mm</td>
        <td>439mm</td>
        <td>439mm</td>
      </tr>
      <tr>
        <td>BBD.</td>
        <td><span class="value">Bottom bracket drop</span> <span class="unit">(mm)</span></td>
        <td>44mm</td>
        <td>44mm</td>
        <td>45mm</td>
        <td>45mm</td>
        <td>45mm</td>
      </tr>
      <tr>
        <td>R.</td>
        <td><span class="value">Reach</span> <span class="unit">(mm)</span></td>
        <td>395mm</td>
        <td>418mm</td>
        <td>439mm</td>
        <td>467mm</td>
        <td>483mm</td>
      </tr>
      <tr>
        <td>S.</td>
        <td><span class="value">Stack</span> <span class="unit">(mm)</span></td>
        <td>606mm</td>
        <td>615mm</td>
        <td>630mm</td>
        <td>639mm</td>
        <td>653mm</td>
      </tr>
      <tr>
        <td>SH.</td>
        <td><span class="value">Wheelbase</span> <span class="unit">(mm)</span></td>
        <td>820mm</td>
        <td>820mm</td>
        <td>820mm</td>
        <td>820mm</td>
        <td>820mm</td>
      </tr>
      <tr>
        <td>WB.</td>
        <td><span class="value">Wheelbase</span> <span class="unit">(mm)</span></td>
        <td>1109mm</td>
        <td>1135mm</td>
        <td>1161mm</td>
        <td>1192mm</td>
        <td>1214mm</td>
      </tr>
    </tbody>
  </table>
</template>
